<template>
  <div class="d-flex h-100 w-100 justify-content-center login-container">
    <div class="align-self-center">
      <div class="card login-panel">
        <div class="card-header">
          <b-navbar-brand><img src="../../assets/kegs-logo-sml.png" v-b-tooltip.hover title="KEGS Field Developer"></b-navbar-brand>
          Login
          <div class="login-controls">
            <button class="btn" @click="openApple" v-b-tooltip.hover title="Install your 2FA app for IOS">
              <icon name="brands/apple"></icon>
            </button>
            <button class="btn" @click="openGA" v-b-tooltip.hover title="Install your 2FA app for Android">
              <icon name="brands/android"></icon>
            </button>
            <button class="btn" @click="openEULA" v-b-tooltip.hover title="License Agreement">
              <icon name="file"></icon>
            </button>
          </div>
        </div>
        <div class="card-body container">
          <b-form @onSubmit.stop.prevent="onSubmit">
            <b-form-group id="usernameGroup"
                          label="Username" label-for="username">
              <b-form-input ref="usernameInput" @keyup.native="kup" id="username"
                            v-model="username" required
                            placeholder="Enter username"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="passwordGroup"
                          label="Password" label-for="password">
              <b-form-input @keyup.native="kup" id="password"
                            type="password" v-model="password" required
                            placeholder="Enter password"
              ></b-form-input>
            </b-form-group>
          </b-form>
          <div class="reminder-text">
            <!--<label class="form-check-label">-->
              <!--<input v-model="rememberMe" type="checkbox" class="form-check-input">-->
              <!--<p>Remember me on this computer</p>-->
            <!--</label>-->
            <label class="form-check-label">
              <input v-model="eula" type="checkbox" checked class="form-check-input">
              <p>Accept <a target="_blank" href="/static/150929 End_User_Licence_Agreement.pdf">License Agreement</a>
              </p>
            </label>
            <div class="login-hr"></div>
            <h6>Forgot your password?</h6>
            <p><b-button variant="secondary" @click.stop.prevent="goToPasswordReset" class="btn-sm">Click here</b-button> to reset your password.</p>

          </div>
        </div>

        <div slot="footer">
          <div class="d-flex">
            <b-btn-group class="btn-block">
              <b-button @click.stop.prevent="goToRegistration" type="submit" variant="dark" class="btn-block btn-sm">Register</b-button>

              <b-button id="login-btn" :disabled="loading" type="submit" @click.stop.prevent="onSubmit" variant="dark" class="btn-block btn-sm">
                Sign in
              </b-button>
            </b-btn-group>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import 'vue-awesome/icons/envelope'
  import 'vue-awesome/icons/brands/apple'
  import 'vue-awesome/icons/brands/android'
  import 'vue-awesome/icons/file'
  import { series } from 'async'
  import router from '../../router'
  import store from '../../store'

  export default {
    data () {
      return {
        username: null,
        password: null,
        loading: false,
        eula: true,
        rememberMe: false
      }
    },
    mounted () {
      this.$refs.usernameInput.focus()
    },
    methods: {
      goToRegistration () {
        router.push({name: 'reg'})
      },
      goToPasswordReset () {
        router.push({name: 'reset-request'})
      },
      openGA () {
        let url = 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'
        let win = window.open(url, '_blank')
        win.focus()
      },
      openApple () {
        let url = 'https://itunes.apple.com/app/google-authenticator/id388497605?mt=8'
        let win = window.open(url, '_blank')
        win.focus()
      },
      openEULA () {
        let url = '/static/150929 End_User_Licence_Agreement.pdf'
        let win = window.open(url, '_blank')
        win.focus()
      },
      kup (e) {
        if (e.keyCode === 13) {
          this.onSubmit()
        }
      },
      onSubmit () {
        if (!this.eula) {
          this.$notify({
            title: 'ERROR',
            text: 'EULA not accepted',
            type: 'error'
          })
          return
        }
        this.loading = true
        store.commit('user/loading', true)
        series(
          [
            (clb) => {
              let formData = new FormData()
              formData.append('username', this.username)
              formData.append('password', this.password)
              formData.append('remember_me', this.rememberMe)
              this.$http.post('/api/login/', formData)
                .then(response => {
                  clb(null)
                }, response => {
                  clb(response.body)
                })
            },
            (clb) => {
              this.$http.get('/api/authed/')
                .then(res => {
                  clb(null, res.body)
                }, res => {
                  clb(res.body)
                })
            }
          ],
          (err, res) => {
            this.loading = false
            store.commit('user/loading', false)
            if (err) {
              this.$notify({
                title: 'ERROR',
                text: 'Could not sign in',
                type: 'error'
              })
            } else {
              if (res[1].authed) {
                store.commit('user/authed', true)
                store.commit('user/user', res[1].user)
                store.commit('user/firstLoad', true)
                router.push('/')
              }
            }
          }
        )
      }
    }
  }
</script>

<style>
  .login-form-body {
    background: rgba(0, 0, 0, 0.3)
  }
</style>



// WEBPACK FOOTER //
// src/components/user/LoginPage.vue